"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitivityLabel = void 0;
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var icons_1 = require("../../../../gen-src/icons");
var LabelPopover_1 = require("../LabelPopover");
var Styles_1 = require("../Styles");
var useControlledPopover_1 = require("../shared/useControlledPopover");
function SensitivityLabel(props) {
    var _a, _b;
    var popover = (0, useControlledPopover_1.useControlledPopover)({
        testId: props.testId,
        popoverProps: {
            title: sensitivityLabelTitle(),
        },
        content: LabelPopover_1.LabelPopover,
        controlKind: (_b = (_a = props.controls) === null || _a === void 0 ? void 0 : _a.kind) !== null && _b !== void 0 ? _b : 'icon',
        iconProps: sensitivityLabelIconProps,
        chipProps: sensitivityLabelChipProps,
        onClick: props.onClick,
        loading: props.loading,
        props: __assign({}, props)
    });
    return popover !== null && popover !== void 0 ? popover : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.SensitivityLabel = SensitivityLabel;
function sensitivityLabelTitle() {
    return Localize_1.Messages.DataQualityTypeSensitiveData();
}
function sensitivityLabelIconProps(props, params) {
    return {
        getContent: props || params ? function (s) { return react_1.default.createElement(SensitivityIcon, { hover: s.hover }); } : undefined,
        style: {
            padding: widgets_1.TabStyles.Spacing.SmallSpace,
            cursor: 'pointer',
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function SensitivityIcon(props) {
    if (props.hover) {
        return react_1.default.createElement(icons_1.SvgWarningHighSeverityActive, { className: Styles_1.LabelIconClass });
    }
    else {
        return react_1.default.createElement(icons_1.SvgWarningHighSeverity, { className: Styles_1.LabelIconClass });
    }
}
function sensitivityLabelChipProps() {
    return {
        type: widgets_1.InlineAlertType.Warning,
        iconContainerStyle: { display: 'inline-flex' },
        kind: 'inline-alert-props'
    };
}
//# sourceMappingURL=SensitivityButton.js.map